var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBatchingNodeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#137FFD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33398 12.5004L11.7621 15.7144C11.8496 15.7582 11.8933 15.78 11.9392 15.7886C11.9798 15.7963 12.0215 15.7963 12.0621 15.7886C12.108 15.78 12.1517 15.7582 12.2392 15.7144L18.6673 12.5004M5.33398 15.8337L11.7621 19.0478C11.8496 19.0915 11.8933 19.1134 11.9392 19.122C11.9798 19.1296 12.0215 19.1296 12.0621 19.122C12.108 19.1134 12.1517 19.0915 12.2392 19.0478L18.6673 15.8337M5.33398 9.16704L11.7621 5.95296C11.8496 5.90923 11.8933 5.88737 11.9392 5.87876C11.9798 5.87114 12.0215 5.87114 12.0621 5.87876C12.108 5.88737 12.1517 5.90923 12.2392 5.95296L18.6673 9.16704L12.2392 12.3811C12.1517 12.4248 12.108 12.4467 12.0621 12.4553C12.0215 12.4629 11.9798 12.4629 11.9392 12.4553C11.8933 12.4467 11.8496 12.4248 11.7621 12.3811L5.33398 9.16704Z",
    stroke: "#EEF9FF",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatchingNodeIcon);
export default __webpack_public_path__ + "static/media/batchingNodeIcon.98fb0ba840cd43344f3c4ce32eb5dbfd.svg";
export { ForwardRef as ReactComponent };